import Vue from "vue";
import VueRouter from "vue-router";
import bank from "../views/bank/nangua/bank.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "bank",
    component: bank,
    meta: {
      title: "南瓜电影 X 省心会员" // 可以在这里设置自定义标题
    }
  },
    {
    path: "/sh",
    name: "sh",
    component: () =>
      import(/* webpackChunkName: "sh" */ "../views/hlb/souhu/sh.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
    {
    path: "/bc",
    name: "bc",
    component: () =>
      import(/* webpackChunkName: "bc" */ "../views/hlb/bc/bc.vue"),
    meta: {
      title: "百川合利宝联合会员"
    }
  },
   {
    path: "/bcpay",
    name: "bcpay",
    component: () =>
      import(/* webpackChunkName: "bcpay" */ "../views/hlb/bc/bcpay.vue"),
    meta: {
      title: "百川合利宝联合会员"
    }
  },
  {
    path: "/xw",
    name: "xw",
    component: () =>
      import(/* webpackChunkName: "xw" */ "../views/hlb/xiaowu/xw.vue"),
    meta: {
      title: "小悟故事 X 省心会员"
    }
  },
  {
    path: "/xwv1",
    name: "xwv1",
    component: () =>
      import(/* webpackChunkName: "xwv1" */ "../views/hlb/xiaowu/xwv1.vue"),
    meta: {
      title: "小悟故事 X 省心会员"
    }
  },
  {
    path: "/xwv2",
    name: "xwv2",
    component: () =>
      import(/* webpackChunkName: "xwv2" */ "../views/hlb/xiaowu/xwv2.vue"),
    meta: {
      title: "小悟故事 X 省心会员"
    }
  },
    {
    path: "/xwv3",
    name: "xwv3",
    component: () =>
      import(/* webpackChunkName: "xwv2" */ "../views/hlb/xiaowu/xwv3.vue"),
    meta: {
      title: "小悟故事 X 省心会员"
    }
  },
  {
    path: "/ys",
    name: "ys",
    component: () =>
      import(/* webpackChunkName: "ys" */ "../views/hlb/yishou/ys.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
  {
    path: "/ysv1",
    name: "ysv1",
    component: () =>
      import(/* webpackChunkName: "ysv1" */ "../views/hlb/yishou/ysv1.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
   {
    path: "/yfb",
    name: "yfb",
    component: () =>
      import(/* webpackChunkName: "yfb" */ "../views/hlb/ysYfb/yfb.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
     {
    path: "/yfbv1",
    name: "yfbv1",
    component: () =>
      import(/* webpackChunkName: "yfbv1" */ "../views/hlb/ysYfb/yfbv1.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
    {
    path: "/ysw",
    name: "ysw",
    component: () =>
      import(/* webpackChunkName: "ysw" */ "../views/hlb/yishou/ysw.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
   {
    //ysv2微信限制了用的v3
    path: "/ysv3",
    name: "ysv3",
    component: () =>
      import(/* webpackChunkName: "ysv2" */ "../views/hlb/yishou/ysv2.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
    {
    //ysv3微信限制了用的v4
    path: "/ysv4",
    name: "ysv4",
    component: () =>
      import(/* webpackChunkName: "ysv2" */ "../views/hlb/yishou/ysv2.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
    {
    //ysv4微信限制了用的v5
    path: "/ysv5",
    name: "ysv5",
    component: () =>
      import(/* webpackChunkName: "ysv5" */ "../views/hlb/yishou/ysv2.vue"),
    meta: {
      title: "宜搜小说 X 省心会员"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404.vue"),
    meta: {
      title: "404"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: '/bank',
  routes,
});

// 路由守卫：每次路由变化时设置页面标题
router.beforeEach((to, from, next) => {
  // 从路由的meta中获取标题，如果没有则使用路由的name
  document.title = to.meta.title || to.name || '';
  next();
});

export default router;